import React, { useState } from "react";
import Swal from "sweetalert2";
import PaymnetServices from "./PaymnetServices";

const getTotalCount = (enguagmenttype) => {
  if (!enguagmenttype) return 12;
  if (enguagmenttype.includes("Yearly")) return 1;
  if (enguagmenttype.includes("Quarterly")) return 4;
  return 12;
};

const extractSubscriptionId = (data) => {
  if (!data) return null;
  if (typeof data === "object") return data.id || data.subscription_id || null;
  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      return parsed.id || parsed.subscription_id || null;
    } catch {
      const m = data.match(/id=([^,}]+)/);
      return m ? m[1].trim() : null;
    }
  }
  return null;
};

const RazorpayCheckout = ({ handlePaymentUpdate, plan }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePayment = async () => {
    const planId = plan?.subscriptionpricies?.[0]?.planid;
    if (!planId) {
      Swal.fire("Plan not linked to Razorpay yet. Ask SuperAdmin to click Create Plan.", "", "warning");
      return;
    }
    const razorKey = process.env.REACT_APP_RAZOR_PAY_KEY;
    if (!razorKey) {
      Swal.fire("Razorpay key missing in .env (REACT_APP_RAZOR_PAY_KEY).", "", "error");
      return;
    }
    if (!window.Razorpay) {
      Swal.fire("Razorpay SDK not loaded. Check internet / index.html checkout.js.", "", "error");
      return;
    }
    setIsLoading(true);
    try {
      const reqdata = {
        planId,
        totalCount: getTotalCount(plan?.enguagmenttype),
        customerNotify: true,
      };
      const response = await PaymnetServices.CreateSubscription(reqdata);
      if (response?.data?.error) {
        throw new Error(typeof response.data.error === "string" ? response.data.error : JSON.stringify(response.data.error));
      }
      const subscriptionId = extractSubscriptionId(response.data);
      if (!subscriptionId) {
        throw new Error("Failed to create subscription (no id from backend).");
      }

      const options = {
        key: razorKey,
        subscription_id: subscriptionId,
        name: "Finanzz",
        description: plan?.description || plan?.title || "Subscription",
        handler: async function (rzpResponse) {
          try {
            const verificationResponse = await PaymnetServices.VerifySubscriprionPayment(rzpResponse);
            const verificationData = verificationResponse.data;
            if (verificationData?.status === "Payment verified successfully") {
              Swal.fire("Payment verified!", "", "success");
              handlePaymentUpdate(true, plan);
            } else {
              Swal.fire(verificationData?.error || "Payment verification failed!", "", "error");
              handlePaymentUpdate(false, plan);
            }
          } catch (verifyErr) {
            const msg = verifyErr?.response?.data?.error || verifyErr?.response?.data?.status || "Payment verification failed!";
            Swal.fire(msg, "", "error");
            handlePaymentUpdate(false, plan);
          } finally {
            setIsLoading(false);
          }
        },
        prefill: {
          name: "Customer",
          email: "customer@example.com",
          contact: "9999999999",
        },
        notes: {
          address: "Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
      };
      setIsLoading(false);
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (resp) {
        console.error("Payment Failed:", resp?.error);
        Swal.fire("Payment failed. Please try again.", "", "error");
        handlePaymentUpdate(false, plan);
        setIsLoading(false);
      });
      rzp.open();
    } catch (error) {
      console.error("Error in Razorpay payment:", error);
      Swal.fire(error?.response?.data?.error || error.message || "An error occurred. Please try again.", "", "error");
      handlePaymentUpdate(false, plan);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handlePayment}
        disabled={isLoading}
        className="tw-mt-auto tw-w-full tw-text-black tw-bg-[#FDD60E] hover:tw-bg-[#FDD60Ecc] tw-py-3 tw-rounded-lg tw-transition tw-duration-300 tw-outline-none tw-items-center disabled:tw-opacity-60"
      >   {isLoading ? <span className="tw-flex tw-justify-center tw-items-center">
              <svg
                className="tw-animate-spin tw-h-5 tw-w-5 tw-text-black tw-mr-2"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="tw-opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="tw-opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg> Processing...</span>:"Subscribe"}
      </button>
    </div>
  );
};

export default RazorpayCheckout;
